export default {
  authDomain: "https://mylogin.creditsafe.com",
  logoutRedirection: "https://www.creditsafe.com"
};